enum AuthErrorCode {
	AP_7 = 'AP_7',
	US_2 = 'US_2', // User setup required
	US_3 = 'US_3', // disabled company
}

export default AuthErrorCode;
